import { useEffect, useRef, useState } from "react";
import PetInformation from "../PetInformation";

const DeathReport = () => {
  const [value, setValue] = useState(
    "I hereby Certify that  patient, species,sex belonging to clientname  has deceased on Time:                      Date:                       at ",
  );
  const [value2, setValue2] = useState(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRef2 = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  useEffect(() => {
    adjustHeight2();
  }, [value2]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };
  const adjustHeight2 = () => {
    if (textareaRef2.current) {
      textareaRef2.current.style.height = "auto"; // Reset height
      textareaRef2.current.style.height = `${textareaRef2.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div>
      <div>
        <PetInformation />
      </div>
      <div className="gap-2 flex">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value} // Controlled component to retain content
          onChange={(e) => setValue(e.target.value)}
          onInput={adjustHeight}
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>
      <div className="gap-2 flex  w-full flex-col pt-3">
        <p className=" font-semibold  border-gray-500 underline ">INTERPRETATION/COMMENTS:</p>{" "}
        <textarea
          ref={textareaRef2}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value2} // Controlled component to retain content
          onChange={(e) => setValue2(e.target.value)}
          onInput={adjustHeight2}
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value2}</div>
      </div>

      <div className="gap-2 flex  items-center w-full pt-3">
        <p className="text-sm">Doctor's Name</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="gap-2 flex  items-center w-full pt-3">
        <p className="text-sm">Doctor's License Number:</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default DeathReport;
